// Module
var code = "<div class=\"basket-empty-message\"> [[YourCartEmpty]] </div>";
// Exports
module.exports = code;